import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useEffect,useLocation,useParams } from "react";
import axios from "axios";
import { useState } from "react";
import "./index.css";
import { Link } from "react-router-dom";
import left from './images/leftarrow.webp';
import right from './images/rightarrow.webp';
// import oprationcin from './images/operation-icon.svg';
// import synergycin from './images/synergycin.svg';
import blueLine from './images/blueLine.webp';
// import blog1 from "./images/blogdumyimg.png";
import blogwhitearrow from './images/blogwhitearrow.webp';
import FeatureSection from "./featureSection";
// Import images from assets folder
import seamlessicon from "./images/seamlessicon.webp";
import icon2 from "./images/icon2.webp";
import icon3 from "./images/icon3.webp";
import icon4 from "./images/icon4.webp";
import icon5 from "./images/icon5.webp";
import icon6 from "./images/icon6.webp";
import toodhulisticon from "./images/toodhulisticon.webp";
import buildbluearrow from "./images/buildbluearrow.webp";
import buildoperation360icon from "./images/buildoperation360icon.webp";
import buildsynergy360icon from "./images/buildsynergy360icon.webp";
import easierlistedicons from "./images/easierlistedicons.webp";
import Vectorblue from "./images/Vectorblue.webp";
// import howtoodhusideimg from "./images/howtoodhusideimg.png";
// import icon2 from "./images/icon2synergy.svg";
import TestimonialsSection from "./testimonial";
import { Navbar } from "react-bootstrap";
// import locksympl from "./images/locksympl.png";
// import independsympl from "./images/independsympl.png";
import blackroundedarrow from "./images/blackroundedarrow.webp";
import NavbarComnent from "./navbar";
import Footer from "./footer";
import OurFeature from "./homeFeaturesectio";
import { Helmet } from "react-helmet";

const ToodhuLanding = ({  } ) => {
   const [posts, setPosts] = useState([]);
// Feature list with unique descriptions
const features = [
    {
      title: "Seamless Information Exchange",
      icon: seamlessicon,
      description: "Toodhu enhances real-time communication and collaboration through powerful business management software. As a business management software, it ensures smooth data flow, faster decisions, and drives growth with automation and digital tools."
    },
    {
      title: "Comprehensive Data Management",
      icon: icon2,
      description: "Manage all your data with Toodhu’s powerful business management software. This small business management software streamlines contacts, sales, support, and tasks, while integrated small business order management software boosts productivity and accuracy. Intelligent automation and digital tools provide a clear view of your business."
    },
    {
      title: "Enhanced Sourcing Capabilities",
      icon: icon3,
      description: "Discover global opportunities with Toodhu’s advanced business management software. Simplify sourcing, request quotes easily, and expand your supplier network using small business order management software tools. Intuitive small business management software features and intelligent automation streamline procurement and accelerate growth."
    },
    {
      title: "Real-Time Insights & Decision Making",
      icon: icon4,
      description: "Gain real-time insights with Toodhu’s powerful business management software. Make informed decisions through intuitive small business management software, supported by accurate data flow from small business order management software tools. With intelligent automation and digital collaboration."
    },
    {
      title: "Dynamic Pitching Solutions",
      icon: icon5,
      description: "Pitch to clients confidently with Toodhu’s dynamic business management software. Create tailored proposals using intuitive small business management software features, and integrate real-time data with small business order management software. Intelligent automation and collaboration tools streamline your process and maximize impact."
    },
    {
      title: "Organized Data to Work Efficiently",
      icon: icon6,
      description: "Toodhu organizes your data through intelligent business management software, making it easy to access and use. With everything in one place, this small business management software helps you manage files, track tasks, and oversee operations efficiently. Toodhu’s small business order management software keeps critical data centralized and actionable. "
    }
  ];
  

  // const fallbackRecentImages = [recentpostImag1, recentpostImag2, recentpostImag3, recentpostImag4];


   const [isTablet, setIsTablet] = useState(false);
  
    // Function to check window size
    const checkWindowSize = () => {
      if (window.innerWidth <= 1024) {
        setIsTablet(true);
      } else {
        setIsTablet(false);
      }
    };
  
    // Add event listener on component mount
    useEffect(() => {
      checkWindowSize();
      window.addEventListener('resize', checkWindowSize);
  
      return () => {
        window.removeEventListener('resize', checkWindowSize);
      };
    }, []);
  
    useEffect(() => {
      // Scroll to the top of the page on component mount
      window.scrollTo(0, 0);
  }, []);  




  // useEffect(() => {
  //   setCurrentPage(1); // reset to first page


  // }, [filterValue, filterValueNew]);


  // useEffect(() => {
  //   axios.get(`https://fittex.io/jeevanapi/api/apptoodhublog?type=c`)
  //     .then(response => {
  //       const PostList = response.data?.data?.blogInfo;
  //       setPosts(Array.isArray(PostList) ? PostList : []);
  //     })
  //     .catch(error => {
  //       console.error("Error fetching posts by category:", error);
  //     });

  //   },);



  useEffect(() => {
  axios.get(`https://fittex.io/jeevanapi/api/apptoodhublog?type=c`)
    .then(response => {
      const PostList = response.data?.data?.blogInfo;
      setPosts(Array.isArray(PostList) ? PostList : []);
    })
    .catch(error => {
      console.error("Error fetching posts by category:", error);
    });
}, []); // Add an empty dependency array here

  

  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % features.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + features.length) % features.length);
  };



  const schemaData = {
   "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "Toodhu",
    "url": "https://toodhu.com/",
    "logo": "https://toodhu.com/static/media/Toodhulogo.6557fdbeb7c18886ad017389da1f9e4e.svg",
    "description": "Toodhu Business Management Software improves collaboration with CRM for small businesses, optimizing workflow and customer service.",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "S.f.no 277/1A,Annamalai industrial park,kalapatti",
      "addressLocality": "Coimbatore",
      "addressRegion": "TamilNadu",
      "postalCode": "641048",
      "addressCountry": "India"
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+914222981233",
      "contactType": "Customer Service",
      "areaServed": "India",
      "availableLanguage": "English"
    },
    "sameAs": [
      "https://www.facebook.com/toodhu",
      "https://www.twitter.com/toodhu",
      "https://www.instagram.com/toodhu"
    ],
    "publisher": {
      "@type": "Organization",
      "name": "Toodhu",
      "logo": "https://toodhu.com/static/media/Toodhulogo.6557fdbeb7c18886ad017389da1f9e4e.svg"
    },
    "potentialAction": {
      "@type": "SearchAction",
      "target": "https://toodhu.com/?s={search_term_string}",
      "query-input": "required name=search_term_string"
    }
  };






  return (
    <>
   <Helmet>
   <title>Free Online AI Powered Business Management Software - Toodhu</title>
<meta charset="utf-8"/>
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1" />
<meta name="description" content="Boost efficiency with free business management software— to automate tasks, centralize data & scale operations. Try Toodhu’s free AI-powered tool today!"/>
<meta name="keywords" content="Business management software, CRM for small businesses, Digital transformation solutions"/>
<link rel="canonical" href="https://toodhu.com" />
<meta name="robots" content="index,follow"/>
<meta property="og:title" content="Free Online AI Powered Business Management Software - Toodhu"/>
<meta property="og:site_name" content="Toodhu"/>
<meta property="og:url" content="https://toodhu.com/business-management-software"/>
<meta property="og:description" content="Boost efficiency with free business management software— to automate tasks, centralize data & scale operations. Try Toodhu’s free AI-powered tool today!"/>
<meta property="og:type" content="website"/>
<meta property="og:image" content=""/>
<meta name="twitter:card" content="summary_large_image"/>
<meta name="twitter:site" content="https://toodhu.com/business-management-software"/>
<meta name="twitter:title" content="Free Online AI Powered Business Management Software - Toodhu"/>
<meta name="twitter:description" content="Boost efficiency with free business management software— to automate tasks, centralize data & scale operations. Try Toodhu’s free AI-powered tool today!"/>
<meta name="twitter:image" content=""/>

<script type="application/ld+json">{JSON.stringify(schemaData)}</script>


   </Helmet>
    <div className="homesection">
    <div>   
   


{/* <div className="heroSection">
     
      <section className="text-center py-5">
        <h1 className="herotitle">Build collaborative experiences <br></br> faster Together.</h1>
        <p className="text-muted">Unlocking Efficiency with Seamless Collaboration and Smart Management.</p>
        <button className="btn btn-dark mt-3">Start building for free</button>
      </section>


      <div className="container d-flex justify-content-center" id="cardconatiner">
        <div className="row g-4 w-75 cardrw">
            
                   <div className="col-md-6 col-sm-12 opratincard" >
            <div className="p-4 text-center cardssec">
              <h4 className="fw-bold">Operation <span className="text-primary">360</span></h4>
              <img src={oprationcin} alt="Operation Icon" className="OperationIcon" />
              <p className="text-muted text-center Operationpara">Simplify your business management by handling contacts, sales, customer support, and tasks all in one place. It helps you manage files, billing, and gain insights to boost efficiency and productivity.</p>
            </div>
            <div className="explobtn">
            <Link to="/operation360" className="text-decoration-none text-primary fw-bold text-center mx-auto">Explore →</Link>
            </div>
          
          </div>
           
      
          <div className="col-md-6 col-sm-12 opratincard">
            <div className="p-4 text-center cardssec">
              <h4 className="fw-bold">Synergy <span className="text-primary">360</span></h4>
              <img src={synergycin} alt="Operation Icon" className="OperationIcon" />
              <p className="text-muted text-center Operationpara">Explore unlimited possibilities for sourcing and Easily connect with global suppliers, get quotes quickly, and simplify your seasonal planning. Elevate your business with customized tools and exceptional networking opportunities.</p>
            </div>
            <div className="explobtn">
            <Link to="/synergy360" className="text-decoration-none text-primary fw-bold text-center mx-auto">Explore →</Link>
            </div>
          
          </div>
        </div>
      </div>

     <div className="dumycontnt">
     Elevate Your Business with Seamless Operations and Real-Time Collaboration  </div>


</div> */}

<div className="hero-section">
<NavbarComnent/>
      <div className="container text-center py-5">
        <div className="herobuild">Build collaborative experiences
        faster Together.</div>
        <p className="heropara">Unlocking Efficiency with Seamless Collaboration and Smart Management. </p>
       <Link to="/contactform"><button className="startbuildbtn">Start building now <span><img src={buildbluearrow} style={{width:'14%'}}/></span></button></Link> 
      </div>
      <div className="container d-flex justify-content-center mt-5">
        <div className="row">
          <div className="col-lg-6 mb-4 ">
            <div className="info-card toodhuoperation">
              <h4><img src={buildoperation360icon}/> Operation 360</h4>
              <p className="operationcontent">Simplify your business management by handling contacts, sales, customer support, and tasks all in one place. It helps you manage files, billing, and gain insights to boost efficiency and productivity.</p>
             <Link to="/operation360"><button className="btn btn-dark explrebtn">Explore <img src={Vectorblue}/></button></Link>
            </div>
          </div>
          <div className="col-lg-6 mb-4">
            <div className="info-card toodhuoperation">
              <h4><img src={buildsynergy360icon} style={{width:'14%'}}/> Synergy 360</h4> 
              <p className="operationcontent">Explore unlimited possibilities for sourcing and Easily connect with global suppliers, get quotes quickly, and simplify your seasonal planning. Elevate your business with customized tools and exceptional networking opportunities.</p>
              <Link to="/synergy360"> <button className="btn btn-dark explrebtn">Explore <img src={Vectorblue}/></button></Link>
            </div>
          </div>
        </div>
      </div>
    </div>


    </div>


    <br></br>
    <br></br>
    <br></br>

<div className="missionsec">
<div className="missiontxt">Our Mission</div>
<h1 className="empowerinftxt">Empowering businesses with collaboration and intelligent automation, Toodhu boosts efficiency, strengthens customer relationships, and drives growth through digital solutions. <span className="empowerspantxt">As a leading business management software, it supports small business order and management needs for long-term digital transformation.</span></h1>
</div>



{/* <div className="futurecolor">
<div className="container py-5 futuresec" >

<div className="text-center mb-4">
  <p className="futuretle">FUTURE</p>
  <h2 className="futurepara">
    Experience the <span className="textpurple">Future of Data <br /> Collaboration</span> with Toodhu
  </h2>
</div>

<div className="row g-4">
  {features.map((feature, index) => (
    <div key={index} className="col-md-6 col-lg-4">
      <div className="feature-card p-4 ">
        <div className="icon mb-3">
          <span><img src={blueLine} className="blueLineimg"/></span><img src={feature.icon} alt={feature.title} className="img-fluid" width="40" />
        </div>
        <h5 className="">{feature.title}</h5>
        <p className="featuretxtmuted">{feature.description}</p> 

      </div>
    </div>
  ))}
</div>
</div>
</div> */}



<div className="futurecolor">
      <div className="container py-5 futuresec">
        {/* Section Header */}
        <div className="text-center mb-4">
          <p className="futuretle">FUTURE</p>
          <h2 className="futurepara">
            Experience the <span className="textpurple">Future of Data <br /> Collaboration</span> with Toodhu
          </h2>
        </div>

        {/* Slider for Mobile */}
        <div className="slider-container d-block d-md-none">
          <div className="slider-wrapper" style={{ transform: `translateX(-${currentIndex * 100}%)` }}>
            {features.map((feature, index) => (
              <div key={index} className="slide">
                <div className="feature-card p-4">
                <div className="d-flex bluelinebx">
                  <img src={blueLine} className="bluelineimg"  />
                <div className="icon mb-3">
                  <span><img src={feature.icon} alt={feature.title} className="img-fluid" width="40" /></span>
                </div>
                </div>
                  <h5>{feature.title}</h5>
                  <p className="featuretxtmuted">{feature.description}</p>
                </div>
              </div>
            ))}
          </div>
          {/* Navigation */}
          <button className="prev-btn" onClick={prevSlide}><img src={left}/></button>
          <button className="next-btn" onClick={nextSlide}><img src={right  }/></button>  
        </div>

        {/* Normal Grid for Desktop */}
        <div className="row g-4 d-none d-md-flex">
          {features.map((feature, index) => (
            <div key={index} className="col-md-6 col-lg-4">
              <div className="feature-card p-4">
                <div className="d-flex bluelinebx">
                  <img src={blueLine} className="bluelineimg"/>
                <div className="icon mb-3">
                  <span><img src={feature.icon} alt={feature.title} className="img-fluid" width="40" /></span>
                </div>
                </div>

                <h5>{feature.title}</h5>
                <p className="featuretxtmuted">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>





{/* <div className="exchangesection">

<div className="content1">
Toodhu ensures secure Collaboration <br /> within its ecosystem.
</div>


<div className="content2div">
<div className="content2title">
Independence and  Isolation
</div>
<div className="content2para">
Toodhu allocates a dedicated application and database  to each <br /> member, creating a secure and isolated  environment for their <br /> data. This ensures that your  information remains confidential and  <br /> protected from  unauthorized access
</div>
</div>


<div className="content3div">
<div className="content3title">
Selective  Data Sharing</div>
<div className="content3para">
Toodhu empowers members to have full control over  their data sharing  <br />  preferences. Whether it's product  specifications, service details, or other  <br />  sensitive  information, members can selectively & maintain  confidentiality  <br />  while collaborating efectively with  trusted partners.
</div>
</div>


<div className="content4div">
<div className="content4title">
Encryption and  Compliance</div>
<div className="content4para">
Toodhu employs industry-standard encryption protocols to safeguard <br /> data during transmission and  storage. Additionally, TexDx adheres to <br /> strict  compliance standards, ensuring that member data  remains <br /> compliant with relevant regulations and  industry best practices.
</div>
</div>



<div className="content5div">
<div className="content5title">
Auditing and  Monitoring</div>
<div className="content5para">
Toodhu incorporates robust auditing and monitoring  features to track data <br /> access and usage across the  platform. Members can monitor who accessed <br /> their  shared data, what actions were taken and <br /> providing  transparency and accountability through out the  collaboration process
</div>
</div>



</div> */}


{/* <div className="exchangesectionmbile">


<div className="exchangembiletile">The<br /> Exchange</div>
<div className="exchangembilepara">Toodhu ensures secure <br /> <span className="securetxt">Collaboration within its ecosystem.</span></div>
<div className="locklist1">
  <div className="locktitle1">Independence and  Isolation</div>
  <div className="lockpara1">Toodhu ensures that your business data remains private and secure by isolating sensitive information. Each user and team can operate independently within the platform, with the flexibility to customize workflows while keeping access to critical data secure. This isolation minimizes the risk of unauthorized access and maintains control over your business environment.</div>
</div>

<div className="locklist2">
  <div className="locktitle1">Selective  Data Sharing</div>
  <div className="lockpara1">With Toodhu, you have full control over what data is shared and with whom. Share only the information that’s necessary for collaboration, keeping your business's sensitive details protected. Selective data sharing empowers your team to work together efficiently while maintaining the privacy and security of your most valuable assets.
  </div>
</div>

<div className="locklist3">
  <div className="locktitle1">Encryption and  Compliance  </div>
  <div className="lockpara1">Toodhu takes data security seriously with end-to-end encryption to protect your information both in transit and at rest. We ensure compliance with industry standards and regulations, so you can confidently collaborate knowing that your data is safeguarded and protected against potential breaches or unauthorized access..</div>
</div>

<div className="locklist4">
  <div className="locktitle1">Auditing and  Monitoring</div>
  <div className="lockpara1">Toodhu provides robust auditing and monitoring features to track all actions and interactions within the platform. Every access and data change is logged for complete transparency, allowing you to monitor activity and ensure that everything stays in compliance with your security policies. This continuous oversight helps identify and address any potential security concerns quickly.
  </div>
</div>

</div> */}



<div className="productssection">
<div className="productintialtitle">PRODUCTS</div>
<div className="howourtxt">Transform Your Business with  
<br></br>
Toodhu’s <span className="easiertxt">Smart Solutions</span></div>

<div className="platformlisted">
  <div className="platformbox">
  <div className="row">
<div className="flex col-xl-6 ">
  <div className="platformlist1">
  <div className="row">
<div className="col-xl-1">
  <img src={easierlistedicons} className="easiericons"/>
</div>
<div className="col-xl-11 easier" id="">
<div className="seamlesssynergytitle">Seamless Resource Planning & Collaboration <br></br> with  Synergy 360 </div>
<div className="easier1">
  <div className="listingtitle">RM Planner for Optimized Resource Allocation </div>
  <div className="listingpara">Plan, allocate, and manage resources efficiently with automated tracking.
  </div>
  </div>

  <div className="easier2">
  <div className="listingtitle">Centralized Catalogue for Easy Access 
  </div>
  <div className="listingpara">Organize, update, and share product or service catalogs seamlessly in one place.
  </div>
  </div>



  <div className="easier3">
  <div className="listingtitle">Indent Tracking for Better Control
  </div>
  <div className="listingpara">Monitor indent status seamlessly to enhance procurement and inventory control. 
  </div>
  </div>


  <div className="easier4">
  <div className="listingtitle">Seamless Collaboration to Optimize Productivity 
  </div>
  <div className="listingpara">Improve teamwork with shared workspaces, document access, and workflow integration.  
  </div>
  </div>






</div>
</div>
  </div>

</div>
<div className="flex col-xl-6 " >
  <div className="platformlisttwo">
  <div className="row">
<div className="col-xl-1">
  <img src={easierlistedicons} className="easiericons"/>
</div>

<div className="col-xl-11 streamelinedoperation">
<div className="seamlesssynergytitle" id="seamlesssynergytitle">Seamless Resource Planning & Collaboration <br></br> with  Operation 360 </div>
<div className="streamelinedoperation1">
  <div className="listingtitle">Lead Management for Conversions
  </div>
  <div className="listingpara">Capture, track, and convert potential leads efficiently with a structured pipeline.  

  </div>
  </div>

  <div className="streamelinedoperation2">
  <div className="listingtitle">Customer Tickets & Task Automation:
  </div>
  <div className="listingpara">Handle customer queries and internal tasks smoothly using automated workflows.  

  </div>
  </div>

  <div className="streamelinedoperation3">
  <div className="listingtitle">Secure Digital File Management System
  </div>
  <div className="listingpara">Store, organize, and access critical business documents securely in the cloud.

  </div>
  </div>

  <div className="streamelinedoperation4">
  <div className="listingtitle">Automated Purchase & Sales Transactions

  </div>
  <div className="listingpara">Streamline procurement and sales processes with real-time tracking and reporting.


  </div>
  </div>

  


  </div>
</div>
  </div>

</div>

</div>
  </div>

</div>

</div>




{/* <div>
<TestimonialsSection/>
</div> */}


<div>
  <OurFeature/>
</div>



<div className="howtoodhusection">
<div class="container toodhucontainer my-5">
    <div class="content-section row align-items-center">

      <div class="col-lg-7 mb-4 mb-lg-0 howtoodhusec" >
        <div className="howtoodhutxt">How Toodhu transforms your Business Efficiency</div>
        <ul class="list-unstyled mt-4">
          <li class="iconlist"><span><img src={toodhulisticon} className="toodhulisticon"/></span>Streamline communication and teamwork with real-time collaboration tools and shared workspaces.</li>
          <li class="iconlist"><span><img src={toodhulisticon} className="toodhulisticon"/></span>Automate workflows and task management to reduce manual efforts and improve efficiency.</li>
          <li class="iconlist"><span><img src={toodhulisticon} className="toodhulisticon"/></span>Securely store, access, and manage business data anytime with cloud-based accessibility.</li>
          <li class="iconlist"><span><img src={toodhulisticon} className="toodhulisticon"/></span>Gain real-time analytics and insights to optimize operations and make data-driven decisions.</li>
          <li class="iconlist"><span><img src={toodhulisticon} className="toodhulisticon"/></span>Improve overall business productivity by optimizing resources and enhancing performance.</li>
        </ul>
      </div>
      

      <div class="col-lg-5 ">
        <div class="didgitaldashoard mx-5">
        </div>
      </div>
    </div>
  </div>
</div>



<section className="container py-5">
  <h6 className="text-center text-uppercase text-purple mb-3 blogpurpletitle">Blogs</h6>
  <h2 className="text-center mb-2">The Future of Business</h2>
  <p className="text-center text-muted mb-5">How Toodhu Transforms Collaboration & Efficiency</p>
  <div className="row">
  {posts.slice(0, 3).map((blog, index) => (
    <div className="col-lg-4 col-md-6 mb-4" key={index}>
<div className="card border-0 shadow-sm rounded-4 h-100 d-flex flex-column">
  <img src={blog.blog_Banner} className="card-img-top rounded-top-4" alt={blog.blog_Header} />
  

  <div className="d-flex flex-column h-100 px-3 pb-4">
    <h5 className="blogstitle flex-grow-1 pt-4">{blog.blog_Header}</h5>
    <p className="post-excerpt">{blog.title}</p>
    

    <Link
      to={`/blogDetails?blogId=${blog.blog_Id}`} 
      className="btn btn-dark rounded-pill mt-auto blogreadbtn px-3 py-1 small d-inline-flex align-items-center gap-1"
    >
      {blog.buttonText || 'Read More'} <span><img src={blogwhitearrow} alt="arrow" style={{ width: '12px', height: '12px' }} /></span>
    </Link>
  </div>
</div>
</div>
  ))}
</div>
</section>



<div className="grttoodhu">
<div className="container-fluid d-flex justify-content-center align-items-center position-relative banner-container">
      <div className="banner-content text-center">
        <div className="gettoodhutext">Get<br />Toodhu</div>
        <Link to="/contactform"> <button className="btn btn-light shadow-sm rounded-pill px-4 py-2 mt-3 getbuildbtn"  >
          Start building for free <span className="ms-1"><img src={blackroundedarrow}/></span>
        </button></Link>
      </div>
    </div>
</div>


<div>
  <Footer/>
</div>







</div>
</>


  );
};

export default ToodhuLanding;